import { Link } from "gatsby"
import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import Button from "../../components/Button/Button"
import ButtonWhite from "../../components/Button/ButtonWhite"
import Video from "../../components/Video/Video"
// import videoOne from "../../assets/video-one.jpg"

const Home = () => {
  const videoId = "fe7PSbFQ7SM"
  return (
    <div className="home">
      <Container fluid={true} className="home__container">
        <Row className="home__row">
          <Col xl={6} className="home__col-left">
            <div className="home__text-wrapper">
              <p className="home__heading headingLegend">
                Welcome to The Growth Engine Revenue Generation Maturity
                Framework Study
              </p>
              <p className="home__text textElement">
                The Revenue Revenue Generation Maturity Framework is developed
                by The Growth Engine, a self assessment to help you understand
                the maturity of your business practices that affect your ability
                to generate revenues and achieve long term growth. This model
                was developed in 2015 and has been supported by empirical
                studies conducted in both North America, and Asia Pacific
                regions. The survey will take you only 5 minutes to complete and
                we will send you a complimentary assessment report within 3
                business days.
              </p>
            </div>
          </Col>
          <Col xl={6} className="home__col-right">
            <div className="home__heading-sec headingLegendBold">
              <strong>How it works</strong>
            </div>
            <div className="home__down-arrow">&darr;</div>
            {/* <Video video_id={videoId} thumbnail="" /> */}
            <div className="home__button-wrapper-new">
              <Link to="/SurveySlider/SurveySlider">
                <ButtonWhite label="Start Now &nbsp;&nbsp;&rarr;" />
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Home
